export const crossTable = {
	crossTableVue: {
		instance: '.crossTableVue',
	},
}
